import { useState, useEffect } from "react";
import washingPowder from "../assets/WashingPowder.jpeg";
import glassCleaningLiquid from "../assets/GlassCleaningLiquid.jpeg";
import dishWashGel from "../assets/DishWashGel.jpeg";
import toiletCleaner from "../assets/ToiletCleaner.jpeg";

const products = [
  {
    name: "Washing Powder",
    image: washingPowder,
    description: "Tough on stains, gentle on fabrics",
    features: ["Deep cleaning action", "Fresh fragrance", "Fabric care formula"],
    size: "1kg, 2kg, 5kg"
  },
  {
    name: "Glass Cleaning Liquid",
    image: glassCleaningLiquid,
    description: "Perfect for glass surfaces, leaving them streak-free",
    features: ["Streak-free shine", "Anti-fog formula", "Quick drying"],
    size: "500ml, 1L"
  },
  {
    name: "Dish Wash Gel",
    image: dishWashGel,
    description: "Keeps dishes sparkling clean and grease-free",
    features: ["Cuts through grease", "Gentle on hands", "Lemon fresh scent"],
    size: "250ml, 500ml, 1L"
  },
  {
    name: "Toilet Cleaner",
    image: toiletCleaner,
    description: "Powerful cleaning for a hygienic and fresh toilet",
    features: ["Removes tough stains", "Long-lasting freshness"],
    size: "500ml, 1L"
  }
];

function ProductsShowcase() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [itemsPerView, setItemsPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerView(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, products.length - itemsPerView);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex >= maxIndex ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? maxIndex : prevIndex - 1
    );
  };

  useEffect(() => {
    if (!isPaused && products.length > itemsPerView) {
      const autoPlay = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex >= maxIndex ? 0 : prevIndex + 1
        );
      }, 5000);

      return () => clearInterval(autoPlay);
    }
  }, [isPaused, maxIndex]);

  return (
    <section className="products" id="products">
      <div className="container">
        <h2>Our Premium Product Range</h2>
        <p className="section-subtitle">
          Discover our carefully crafted cleaning solutions for every need
        </p>

        <div
          className="carousel-container"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {products.length > itemsPerView && (
            <button className="carousel-btn prev" onClick={prevSlide}>
              ‹
            </button>
          )}

          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
              }}
            >
              {products.map((product, index) => (
                <div
                  className="carousel-slide"
                  key={index}
                >
                  <div className="product-card">
                    <div className="product-image-wrapper">
                      <img src={product.image} alt={product.name} />
                      <div className="product-badge">New</div>
                    </div>
                    <div className="product-info">
                      <h3>{product.name}</h3>
                      <p className="product-description">{product.description}</p>
                      <ul className="product-features">
                        {product.features.map((feature, idx) => (
                          <li key={idx}>✓ {feature}</li>
                        ))}
                      </ul>
                      <div className="product-footer">
                        <span className="product-size">Size: {product.size}</span>
                        <button className="btn-learn-more">Learn More</button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {products.length > itemsPerView && (
            <button className="carousel-btn next" onClick={nextSlide}>
              ›
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default ProductsShowcase;